import { useCallback, useLayoutEffect, useState } from 'react';
import { useBreakpoint } from '~/components/Breakpoint/Breakpoint.hook';

export const usePlaceholder = (count: number) => {
  const [el, setEl] = useState<HTMLElement | null>();
  const ref = useCallback((el: HTMLElement | null) => {
    setEl(el);
  }, []);
  const breakpoint = useBreakpoint();
  const [length, setLength] = useState(0);

  useLayoutEffect(() => {
    if (!el) return;
    const style = getComputedStyle(el);
    const columns = Number(style.getPropertyValue('--grid-items-per-row') || '1');
    const max = Number(style.getPropertyValue('--grid-max-placeholders') || columns);
    const holders = max - (count % max);
    const length = count < max ? holders : holders % columns;

    setLength(length);
  }, [el, count, breakpoint]);

  return {
    ref,
    length,
  };
};
